import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/employee/list', params)
    },
    save(params) {
        return post('/admin/employee/save',params)
    },
    delete(params) {
        return post('/admin/employee/delete', params)
    }

}